window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
const handleCartCheckoutBtn = ({ shopData, checkoutButton, Tax }) => {
  const defaultBtnCheckout = $(checkoutButton)
    .parent()
    .find("[name='checkout']:not(.bss-checkout)");
  if (defaultBtnCheckout.length > 0) {
    defaultBtnCheckout.addClass("bss_d-none");
    $(".bss-checkout").css("display", "inline");
  }
};
window.BSS_B2B.addAction("fix_handle_cart_checkout_btn", handleCartCheckoutBtn);
if (BSS_B2B) {
  $(".bss-checkout").css("opacity","0.5").css("pointer-events", "none");
  setTimeout(() => {
    $(".bss-checkout").css("opacity","1").css("pointer-events", "unset");
  }, 4000)
}